import React, { useState, useEffect } from 'react';
import { listarUsuariosPendentes, listarUsuariosAtivos, aprovarUsuario, recusarUsuario } from '../lib/supabase';
import { CheckCircle, XCircle, Users, Clock } from 'lucide-react';

export default function Admin() {
  const [pendentes, setPendentes] = useState([]);
  const [ativos,    setAtivos]    = useState([]);
  const [loading,   setLoading]   = useState(true);

  const carregar = async () => {
    setLoading(true);
    const [p, a] = await Promise.all([listarUsuariosPendentes(), listarUsuariosAtivos()]);
    setPendentes(p); setAtivos(a); setLoading(false);
  };

  useEffect(() => { carregar(); }, []);

  const aprovar = async (id) => { await aprovarUsuario(id); carregar(); };
  const recusar = async (id) => { if (window.confirm('Recusar e excluir esta solicitação?')) { await recusarUsuario(id); carregar(); } };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Administração</h1>
          <p className="page-sub">Gerenciar usuários do sistema</p>
        </div>
      </div>

      {loading ? <div className="loading"><div className="spinner" /></div> : (
        <>
          <div className="admin-section">
            <h2 className="admin-section-title"><Clock size={16} /> Solicitações pendentes ({pendentes.length})</h2>
            {pendentes.length === 0 ? (
              <p className="admin-vazio">Nenhuma solicitação pendente.</p>
            ) : pendentes.map(u => (
              <div key={u.id} className="admin-card">
                <div className="admin-avatar">{u.nome?.charAt(0) || u.usuario?.charAt(0)}</div>
                <div className="admin-info">
                  <p className="admin-nome">{u.nome || u.usuario}</p>
                  <p className="admin-user">@{u.usuario}</p>
                </div>
                <div className="admin-acoes">
                  <button className="btn-aprovar" onClick={() => aprovar(u.id)}><CheckCircle size={18} /> Aprovar</button>
                  <button className="btn-recusar" onClick={() => recusar(u.id)}><XCircle size={18} /> Recusar</button>
                </div>
              </div>
            ))}
          </div>

          <div className="admin-section" style={{ marginTop: 28 }}>
            <h2 className="admin-section-title"><Users size={16} /> Usuários ativos ({ativos.length})</h2>
            {ativos.map(u => (
              <div key={u.id} className="admin-card">
                <div className="admin-avatar ativo">{u.nome?.charAt(0) || u.usuario?.charAt(0)}</div>
                <div className="admin-info">
                  <p className="admin-nome">{u.nome || u.usuario}</p>
                  <p className="admin-user">@{u.usuario} · {u.perfil}</p>
                </div>
                <span className="badge badge-verde">Ativo</span>
              </div>
            ))}
          </div>
        </>
      )}

      <style>{`
        .page { padding: 24px; }
        .page-header { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:24px; }
        .page-title { font-size:1.5rem; font-weight:700; color:var(--azul); margin:0; }
        .page-sub { color:#6B7280; font-size:.875rem; margin:2px 0 0; }
        .admin-section-title { font-size:.9rem; font-weight:700; color:#374151; display:flex; align-items:center; gap:6px; margin-bottom:12px; }
        .admin-vazio { color:#9CA3AF; font-size:.875rem; background:#F9FAFB; padding:16px; border-radius:10px; }
        .admin-card { background:#fff; border:1.5px solid #E5E7EB; border-radius:12px; padding:14px 16px; display:flex; align-items:center; gap:12px; margin-bottom:8px; }
        .admin-avatar { width:40px; height:40px; border-radius:50%; background:#E5E7EB; color:#374151; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:1rem; flex-shrink:0; }
        .admin-avatar.ativo { background:var(--azul); color:var(--amarelo); }
        .admin-info { flex:1; }
        .admin-nome { font-weight:600; color:var(--azul); margin:0; font-size:.9rem; }
        .admin-user { color:#9CA3AF; font-size:.8rem; margin:2px 0 0; }
        .admin-acoes { display:flex; gap:8px; }
        .btn-aprovar { display:flex; align-items:center; gap:6px; padding:7px 14px; background:#DCFCE7; color:#16A34A; border:none; border-radius:8px; font-weight:600; font-size:.85rem; cursor:pointer; }
        .btn-aprovar:hover { background:#BBF7D0; }
        .btn-recusar { display:flex; align-items:center; gap:6px; padding:7px 14px; background:#FEE2E2; color:#DC2626; border:none; border-radius:8px; font-weight:600; font-size:.85rem; cursor:pointer; }
        .btn-recusar:hover { background:#FECACA; }
      `}</style>
    </div>
  );
}
